<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row style="border:0px solid green;position: inherit;display:contents;width:100%;">
        <div class="box box-primary">
          <!-- Search container -->
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">{{ $t("search.title") }}</h3>
            </div>
            <div class="box-body">
              <div class="row" style="margin-bottom: 10px;">
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <input
                    v-on:keyup.enter="onSearchProjectHistory"
                    type="text"
                    class="form-control"
                    :placeholder="$t('project_history.full_name')"
                    v-model="search.full_name"
                  />
                </div>
                <!-- <div class="col-sm-3 col-md-3 col-lg-3">
                  <input
                    v-on:keyup.enter="onSearchProjectHistory"
                    type="text"
                    class="form-control"
                    :placeholder="$t('project_history.project_name')"
                    v-model="search.project_name"
                  />
                </div>               -->
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <!-- nhat -->
                  <!-- <select id="author_id" name="author_name">
                    <option>đsa</option>
                  </select> -->
                  <lte-select2
                    :options="actionTypes"
                    @change="onSelectHistoryAction"
                    :placeHolder="$t('project_history.action')"
                    :isAllowClear="true"
                  >
                  </lte-select2>
                  <!-- <lte-section-select2
                    :placeHolder="$t('project_history.action')"
                    @selectData="onSelectHistoryAction"
                    @unselectData="onUnselectHistoryAction"
                    :data="actionTypes"
                  ></lte-section-select2> -->
                  <!-- nhat -->
                </div>
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <lte-select2
                    :options="moduleTypes"
                    @change="onSelectHistoryModule"
                    :placeHolder="$t('project_history.module')"
                    :isAllowClear="true"
                  >
                  </lte-select2>
                  <!-- <lte-section-select2
                    :placeHolder="$t('project_history.module')"
                    @selectData="onSelectHistoryModule"
                    @unselectData="onUnselectHistoryModule"
                    :data="moduleTypes"
                  ></lte-section-select2> -->
                </div>
              </div>
              <div class="row" style="margin-bottom: 0px;">
                <div style="margin-right: 15px">
                  <button
                    type="button"
                    class="btn btn-labeled btn-success pull-right"
                    @click="onSearchProjectHistory"
                  >
                    <span class="btn-label">
                      <i class="glyphicon glyphicon-search"></i>
                    </span>
                    {{ $t("search.search_button") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <!-- <b>{{ $t("project_history.title") }}</b> -->
              <!-- <lte-button
                  style="float:right;background-color:white !important;"
                  type="btn btn-default"
                  right_icon="fa fa-plus"
                  @click="addNew($event)"
              >{{$t('case.addnew')}}</lte-button>-->
              <br />
            </div>
            <select-option-check
              style="margin-top:-40px;"
              @callbackData="onColumnSelect"
              :item="columnsProjectHistory"
              class="dropdown-trigger"
              data-icon="eye"
            ></select-option-check>
          </div>
          <div class="box-body">
            <lte-table
              :hdBackground="hdBackground"
              :data="gridProjectHistoryDataList"
              :columns="gridColumns"
              search_filter="left-search"
              :useFilter="useFilter"
              :boxStyle="boxStyle"
              :row_mouse_pointer="false"
            ></lte-table>
            <div class="box-footer clearfix" style="display:contents; padding: 0 5px">
              <paginator :item="paginatorItem" @onpaginate="onPagination" />
            </div>
          </div>
        </div>
        <!--  -->
        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar"
        ></lte-core-alert>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
      </row>
    </div>
  </div>
</template>
<script>
import Paginator from "@/components/Paginator.vue";
import { mapGetters, mapActions } from "vuex";
// import { LTEActionTypeEnum } from '@/components/LTEEnum'
// import LTEButton from "@/components/LTEButton.vue";
import LTETable from "@/components/LTETable.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import utils from "@/lib/utils";
import i18n from "../../lang";
import Loading from "vue-loading-overlay";
import constants from "@/lib/constantsData";
import SelectOptionCheck from "@/components/SelectOptionCheck.vue";
import Select2 from "@/components/LTESelect2Input.vue";

export default {
  name: "ProjectHistory",
  data() {
    return {
      paginatorItem: {
        commit_function: "GET_PROJECT_HISTORY_LIST"
      },
      buttonName: "danger",
      labelName: "Name",
      groupUserID: 4,
      gridProjectHistoryDataList: [],
      useFilter: false,
      boxStyle: false,
      gridColumns: [
        { text: "common.nonumber", isHidden: true },
        { text: "project_history.full_name", isHidden: true, wrapText: 'nowrap' },
        // { text: "project_history.project_name", isHidden: true },
        { text: "project_history.action", isHidden: true, wrapText: 'nowrap' },
        // { text: "project_history.app", isHidden: true },
        { text: "project_history.description", isHidden: true },
        { text: "project_history.module", isHidden: true, wrapText: 'nowrap' },
        { text: "project_history.date_created", isHidden: true, wrapText: 'nowrap' }
      ],
      columnsProjectHistory: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false
      },
      actionTypes: [
        {
          text: this.$t("project_history.add"),
          id: 0
        },
        {
          text: this.$t("project_history.update"),
          id: 1
        },
        {
          text: this.$t("project_history.delete"),
          id: 2
        },
        {
          text: this.$t("project_history.activate_email"),
          id: 3
        }
      ],

      moduleTypes: [],
      historyActionSelect: -1,
      historyModuleSelect: -1,

      hdBackground: "background-color: #4b646f;color:white;border:1px solid white;", //00a65a
      tblBorder: "border: 1px solid orange",
      originalRecordData: [],
      priorityTypes: constants.priorityTypes,
      statusTypes: constants.statusTypes,
      dateOptions: {
        format: "YYYY-MM-DD hh:mm a"
      },
      search: {
        full_name: "",
        project_name: "",
        action: "",
        module: ""
      },
      isLoading: false
    };
  },
  watch: {
    GET_LANG: function() {
      const data = {
        params: {
          page: 1
        }
      };
      this.GET_PROJECT_HISTORY_LIST(data);
    },
    GET_PROJECT_ALL_ALL_MODULE_DATA: function() {
      for (let i = 0, size = this.GET_PROJECT_ALL_ALL_MODULE_DATA.length; i < size; i++) {
        let module_name = "";
        if (
          this.GET_PROJECT_ALL_ALL_MODULE_DATA[i].module_name ==
          "perm_module_service"
        ) {
          module_name =
            "sidebar.decentralizationManagement.modules.perm_module_service";
        }
        if (
          this.GET_PROJECT_ALL_ALL_MODULE_DATA[i].module_name ==
          "perm_module_staff"
        ) {
          module_name =
            "sidebar.decentralizationManagement.modules.perm_module_staff";
        }
        if (
          this.GET_PROJECT_ALL_ALL_MODULE_DATA[i].module_name ==
          "perm_module_customer"
        ) {
          module_name =
            "sidebar.decentralizationManagement.modules.perm_module_customer";
        }
        if (
          this.GET_PROJECT_ALL_ALL_MODULE_DATA[i].module_name ==
          "perm_module_asset"
        ) {
          module_name =
            "sidebar.decentralizationManagement.modules.perm_module_asset";
        }
        if (
          this.GET_PROJECT_ALL_ALL_MODULE_DATA[i].module_name ==
          "perm_module_apartment"
        ) {
          module_name =
            "sidebar.decentralizationManagement.modules.perm_module_apartment";
        }
        if (
          this.GET_PROJECT_ALL_ALL_MODULE_DATA[i].module_name ==
          "perm_module_project"
        ) {
          module_name =
            "sidebar.decentralizationManagement.modules.perm_module_project";
        }
        if (
          this.GET_PROJECT_ALL_ALL_MODULE_DATA[i].module_name ==
          "perm_module_decentralization"
        ) {
          module_name =
            "sidebar.decentralizationManagement.modules.perm_module_decentralization";
        }
        if (
          this.GET_PROJECT_ALL_ALL_MODULE_DATA[i].module_name ==
          "perm_module_invoice"
        ) {
          module_name =
            "sidebar.decentralizationManagement.modules.perm_module_invoice";
        }
        this.moduleTypes.push({
          id: this.GET_PROJECT_ALL_ALL_MODULE_DATA[i].id,
          text: this.$t(module_name)
        });
      }
    },
    PROJECT_HISTORY_LIST: function() {
      this.gridProjectHistoryDataList = [];
      this.PROJECT_HISTORY_LIST.results.forEach((row, i) => {
        let id = row.id;
        let nonumber =
          i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let full_name = utils.getFullName(
          row.user_first_name,
          row.user_last_name,
          i18n.locale
        );
        let project_name = row.project_name;
        // let action = this.$t(
        //   "project_history.action_description[" + row.action + "]"
        // );
        let action = this.checkAction(row.action);
        let app = utils.getApplicationName(constants.applicationTypes, row.app);
        let description = row.description;
        let module = this.$t("module." + row.module + "");
        let date_created = utils.formatSqlDate(row.date_created, null, constants.dateOptions.format_date_time);

        let data = {
          id: id,
          "common.nonumber": nonumber,
          "project_history.full_name": full_name,
          "project_history.project_name": project_name,
          "project_history.action": action,
          "project_history.app": app,
          "project_history.description": description,
          "project_history.module": module,
          "project_history.date_created": date_created
        };
        this.gridProjectHistoryDataList.push(data);
      });
    },
    GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA: function() {
      if (!utils.isNull(this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data)) {
        let newGridColumns = [];
        const viewedColumnsKey = Object.keys(
          this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data.viewed_columns
        );
        const viewedColumns = this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data
          .viewed_columns;
        for (
          let j = 0, sizeOrigin = this.gridColumns.length;
          j < sizeOrigin;
          j++
        ) {
          for (let i = 0, size = viewedColumnsKey.length; i < size; i++) {
            if (this.gridColumns[j].text == viewedColumnsKey[i]) {
              let viewdColumnObject = {};
              viewdColumnObject.text = viewedColumnsKey[i];
              viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[i]];
              newGridColumns.push(viewdColumnObject);
              break;
            }
          }
        }
        this.gridColumns = newGridColumns;
        this.columnsProjectHistory.data_list = this.gridColumns;
      }
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "PROJECT_HISTORY_LIST",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA",
      "GET_PROJECT_ALL_ALL_MODULE_DATA",
      "GET_LANG"
    ])
  },

  methods: {
    checkAction: function(action) {
      if (action == 0) return this.$t(`project_history.action_description[0]`);
      if (action == 1) return this.$t(`project_history.action_description[1]`);
      if (action == 2) return this.$t(`project_history.action_description[2]`);
      if (action == 3) return this.$t(`project_history.action_description[3]`);
    },
    onSelectHistoryAction: function(historyAction) {
      this.historyActionSelect = historyAction.id;
    },
    onSelectHistoryModule: function(historyModule) {
      this.historyModuleSelect = historyModule.id;
    },
    onColumnSelect: function(tables) {
      let tableDataObj = {};
      let tableDataObjChild = {};
      tableDataObjChild["tablename"] = "projecthistory";
      tables.data_list.forEach(element => {
        tableDataObj[element.text] = element.isHidden;
      });
      tableDataObjChild["tablerow"] = tableDataObj;
      this.SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG(tableDataObjChild)
        .then(function() {}.bind(this))
        .catch(function() {}.bind(this));
    },
    onSearchProjectHistory: function() {
      const data = {
        params: {
          page: 1,
          full_name: this.search.full_name,
          project_name: this.search.project_name,
          action: this.historyActionSelect,
          module: this.historyModuleSelect
        }
      };
      this.isLoading = true;
      this.GET_PROJECT_HISTORY_LIST(data).then(
        function() {
          this.isLoading = false;
        }.bind(this)
      );
    },
    onPagination: function(data) {
      const filter = {
        params: {
          page: data.params.page
        }
      };
      this.GET_PROJECT_HISTORY_LIST(filter);
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
      "GET_PROJECT_HISTORY_LIST",
      // "DELETE_CASE",
      "SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_PROJECT_ALL_ALL_MODULE"
    ])
  },
  mounted() {
    const data = {
      params: {
        page: 1
      }
    };
    this.GET_PROJECT_HISTORY_LIST(data);
    this.columnsProjectHistory.data_list = this.gridColumns;
    const filter = {
      params: {
        tablename: "projecthistory"
      }
    };
    this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG(filter);
    this.GET_PROJECT_ALL_ALL_MODULE();
  },

  components: {
    // "lte-button": LTEButton,
    "lte-table": LTETable,
    "lte-core-alert": LTECoreAlert,
    paginator: Paginator,
    loading: Loading,
    "select-option-check": SelectOptionCheck,
    "lte-select2": Select2
  }
};
</script>
<style lang="scss" scoped>
.select2-container--bootstrap .select2-selection {
  border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Project/ProjectHistory.vue